import Encoding from 'encoding-japanese';

/** NOTE: JIS非漢字 1区 - 12区
 * https://ja.wikipedia.org/wiki/JIS_X_0213%E9%9D%9E%E6%BC%A2%E5%AD%97%E4%B8%80%E8%A6%A7
 * https://mp-faq.gmo-pg.com/s/article/F00148
 */
const JIS_NON_KANJI_START = 0x8140;
const JIS_NON_KANJI_END = 0x86fc;

//NOTE: JIS第1水準 https://www.seiho.or.jp/exam/faq/pdf/code.pdf
const JIS_LEVEL1_START = 0x889f;
const JIS_LEVEL1_END = 0x9872;

//NOTE: JIS第2水準 https://www.seiho.or.jp/exam/faq/pdf/code.pdf
const JIS_LEVEL2_START = 0x989f;
const JIS_LEVEL2_END = 0xeaa2;

//NOTE: UnicodeからShift-JIS codeに変換
const unicodeToSjisCode = (unicode: string): string => {
  const unicodeArray = Encoding.stringToCode(unicode); // Convert string to code array
  const sjisArray = Encoding.convert(unicodeArray, {
    to: 'SJIS',
    from: 'UNICODE',
  });
  return sjisArray.map((num) => num.toString(16).toUpperCase()).join('');
};

//NOTE: Shift-JIS codeを数値に変換
const sjisCodeToNumber = (sjisCode: string): number => parseInt(`0x${sjisCode}`, 16);

//NOTE: JIS X 0208に含まれるかどうか
const isJisX0208 = (unicode: string): boolean => {
  const sjisCode = unicodeToSjisCode(unicode);
  const sjisNumber = sjisCodeToNumber(sjisCode);
  return (
    (sjisNumber >= JIS_NON_KANJI_START && sjisNumber <= JIS_NON_KANJI_END) ||
    (sjisNumber >= JIS_LEVEL1_START && sjisNumber <= JIS_LEVEL1_END) ||
    (sjisNumber >= JIS_LEVEL2_START && sjisNumber <= JIS_LEVEL2_END)
  );
};

//NOTE: 半角英数のみかどうかを正規表現で判定
const isHankakuEisu = (unicode: string): boolean => /^[a-zA-Z0-9]*$/.test(unicode);

//NOTE: JIS X 0208に含まれるかどうかを判定
export const containsValidJISX0208Characters = (unicode: string): boolean => {
  if (unicode === '') return false;
  const unicodeStringArray = unicode.split('');
  const result = unicodeStringArray.map((char) => isJisX0208(char) || isHankakuEisu(char));

  return !result.includes(false);
};
